import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Token key en localStorage (debe coincidir con SessionService).
 */
const TOKEN_KEY = 'jrs_auth_token';

/**
 * Interceptor HTTP funcional para añadir el token de autenticación.
 * Se añade automáticamente a todas las peticiones HTTP salientes.
 *
 * Según OpenAPI spec, la autenticación usa Bearer token (JWT).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem(TOKEN_KEY);

  // Si no hay token, continuar sin modificar la petición
  if (!token) {
    return next(req);
  }

  // Clonar la petición y añadir el header de autorización
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq);
};
